import React from 'react'

import { DesignSystemProvider } from '../../theme/Provider'

import { Progress as ProgressBase } from './Progress'
import type { ProgressProps } from './types'

export const Progress: React.FC<ProgressProps> = (props) => (
  <DesignSystemProvider>
    <ProgressBase {...props} />
  </DesignSystemProvider>
)

export type {
  ProgressProps,
  ProgressBarProps,
  ProgressCircleProps,
  ProgressState,
  ProgressBarSize,
  ProgressCircleSize
} from './types'
